import { Backdrop, Fade, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { closeModal } from "../../Redux/modalSlice";

const ModalContainer = (props) => {
    const dispatch = useDispatch();
    const { active } = useSelector((state) => state.modal);

    return (
        <Modal
            open={active}
            onClose={() => dispatch(closeModal())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <BoxStyle className="modal">{props.children}</BoxStyle>
        </Modal>
    );
};

const BoxStyle = styled.div`
    width: 60%;
    padding: 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--white);
    border-radius: 1rem;
    @media screen and(max-width:992px) {
        width: 90%;
    }
    max-height: 90vh;
    overflow: scroll;
`;

export default ModalContainer;
